import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 bg-zinc-950 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-display text-3xl font-extrabold uppercase">
              laze<span className="text-brand">.</span>
            </Link>
            <p className="mt-4 text-sm text-zinc-400 max-w-xs">
              Unfazed minimal streetwear. Small drops, heavyweight fabrics, made to be lived in.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Shop</h4>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><Link to="/shop" className="hover:text-brand">All Products</Link></li>
              <li><Link to="/shop?category=Hoodies" className="hover:text-brand">Hoodies</Link></li>
              <li><Link to="/shop?category=Cargo+Pants" className="hover:text-brand">Cargo Pants</Link></li>
              <li><Link to="/shop?category=Outerwear" className="hover:text-brand">Outerwear</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Help</h4>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><span className="hover:text-brand cursor-pointer">Shipping & Returns</span></li>
              <li><span className="hover:text-brand cursor-pointer">Size Guide</span></li>
              <li><span className="hover:text-brand cursor-pointer">Track Order</span></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-500 mb-4">Follow</h4>
            <div className="flex gap-3">
              <span className="p-2 border border-zinc-800 hover:border-brand hover:text-brand cursor-pointer transition-colors"><Instagram className="h-4 w-4" /></span>
              <span className="p-2 border border-zinc-800 hover:border-brand hover:text-brand cursor-pointer transition-colors"><Twitter className="h-4 w-4" /></span>
              <span className="p-2 border border-zinc-800 hover:border-brand hover:text-brand cursor-pointer transition-colors"><Youtube className="h-4 w-4" /></span>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-widest text-zinc-600">
          <span>© {new Date().getFullYear()} laze. All rights reserved.</span>
          <span>Payments secured via UPI · famgateway</span>
        </div>
      </div>
    </footer>
  );
}
